import type { Offer } from "BrokerTsLib/src/dtos"
import { useEffect, useMemo, useState } from "react"

export const usePriceFilter = (offers: Offer[]) => {
    const [priceRangeFilter, setPriceRangeFilter] = useState<[number, number]>([0, 0])

    const priceFilterFunc = (quote: Offer): boolean => {
        if (!quote.price)
            return true

        return (priceRangeFilter[0] == null || quote.price >= priceRangeFilter[0])
            && (priceRangeFilter[1] == null || quote.price <= priceRangeFilter[1])
    }

    const priceRange = useMemo(() => calculatePriceRange(offers), [offers])

    const isApplied = priceRangeFilter[0] != priceRange[0] || priceRangeFilter[1] != priceRange[1]

    const resetPriceFilter = () => setPriceRangeFilter(priceRange)

    // reset filter when offers price range change
    useEffect(() => {
        setPriceRangeFilter(priceRange)
    }, [priceRange])

    return {
        isApplied,
        priceRangeFilter,
        setPriceRangeFilter,
        priceFilterFunc,
        resetPriceFilter,
        priceRange
    }
}

const calculatePriceRange = (offers: Offer[]): [number, number] => {
    const validOffers = offers.filter(x => x.price)
    if (validOffers.length == 0)
        return [0, 0]
    else if (validOffers.length == 1)
        return [validOffers[0].price, validOffers[0].price]

    return [
        Math.floor((validOffers.reduce((prev, curr) => prev.price < curr.price ? prev : curr).price)),
        Math.ceil((validOffers.reduce((prev, curr) => prev.price > curr.price ? prev : curr).price))
    ]
}